import useProtectedQuery from "./use-protected-query";

import RebatesClient from "../RebatesClient";

export default function useUsers() {

	const {
		data: valleyUsers,
		isLoading: valleyUsersLoading,
		error: valleyUsersError,
		refetch: valleyRefetchUsers,
	} = useProtectedQuery({

		queryKey: ["get_valley_users"],
		queryFn: async () => {

			let url = `/api/user/get-valley-users`;
			// console.log(url)
			const result =  await RebatesClient.standardFetch(url);

			if (result.response.ok) {
				return result.body.users;
			} else {
				throw new Error("Error getting valley users");
			}
		},
	});

	return {
		valleyUsers,
		valleyUsersLoading,
		valleyUsersError,
		valleyRefetchUsers,
	};
}
